import React, { useEffect } from 'react';
import { initMetaPixel } from './lib/metaPixel';
import { HeroSection } from './components/HeroSection';
import { OpeningHook, ProblemSection, FailedMethodsSection } from './components/ContentSections';
import { MethodCACSection, WhatYouGetSection } from './components/MethodSection';
import { WhoForNotForSection, HowItWorksSection } from './components/ProductSections';
import { ProofSection, FAQSection, OfferSection } from './components/ClosingSections';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <main className="min-h-screen bg-cream font-sans text-brown-dark selection:bg-teal-200 selection:text-teal-900" data-id="element-0">
      <HeroSection data-id="element-1" />
      <OpeningHook data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <FailedMethodsSection data-id="element-4" />
      <MethodCACSection data-id="element-5" />
      <WhatYouGetSection data-id="element-6" />
      <WhoForNotForSection data-id="element-7" />
      <HowItWorksSection data-id="element-8" />
      <ProofSection data-id="element-9" />
      <FAQSection data-id="element-10" />
      <OfferSection data-id="element-11" />

      <Footer data-id="element-12" />
    </main>;
}